import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import DragDropComponente from '@componentes/dragdrog/dragdrop.componente';
import TaretasFiltroPage from './tarefas.filtro.page';
import '../citologia/content/citologia.styles.css';
import './tarefas.styles.css'

const TarefasKanbanPage = ({ tarefasFiltroPageProps, dragDropComponente }) => {
  const styleAlturaKanbam = {
    height: dragDropComponente.alturaKanbam,
    overflow: 'scroll',
    overflowX: 'hidden'
  };

  return (
    <div className='citologia-page tarefas-medico'>
      <Container fluid>
        <Row>
          <Col>
            <TaretasFiltroPage
              filtrar={tarefasFiltroPageProps.filtrar}
              usuario={tarefasFiltroPageProps.usuario}
              carregando={tarefasFiltroPageProps.carregando}
              medicos={tarefasFiltroPageProps.medicos}
              optionsFiltroInputTypeSelect={tarefasFiltroPageProps.optionsFiltroInputTypeSelect}
              optionFiltroInputTypeSelectSelecionada={tarefasFiltroPageProps.optionFiltroInputTypeSelectSelecionada}
              medicoSelecionado={tarefasFiltroPageProps.medicoSelecionado}
              periodoInicial={tarefasFiltroPageProps.periodoInicial}
              periodoFinal={tarefasFiltroPageProps.periodoFinal}
              onChangeData={tarefasFiltroPageProps.onChangeData}
              onChangeSelect={tarefasFiltroPageProps.onChangeSelect}
              onChangeMedico={tarefasFiltroPageProps.onChangeMedico}
              onChangeNumeroExame={tarefasFiltroPageProps.onChangeNumeroExame}
              onChangeInputText={tarefasFiltroPageProps.onChangeInputText}
              onKeyPressNumeroExame={tarefasFiltroPageProps.onKeyPressNumeroExame}
              onKeyPressInputText={tarefasFiltroPageProps.onKeyPressInputText}
              numeroDoExame={tarefasFiltroPageProps.numeroDoExame}
              numeroDoExameRef={tarefasFiltroPageProps.numeroDoExameRef}
              onChangeTipoFiltro={tarefasFiltroPageProps.onChangeTipoFiltro}
              tipoFiltroSelecionado={tarefasFiltroPageProps.tipoFiltroSelecionado}
              tipoFiltroValue={tarefasFiltroPageProps.tipoFiltroValue}
              periodos={tarefasFiltroPageProps.periodos}
              periodo={tarefasFiltroPageProps.periodo}
              onChangePeriodo={tarefasFiltroPageProps.onChangePeriodo}
              mudarIntervaloPeriodo={tarefasFiltroPageProps.mudarIntervaloPeriodo}
              onKeyPressData={tarefasFiltroPageProps.onKeyPressData}
            />
          </Col>
        </Row>
        <Row style={styleAlturaKanbam}>
          <DragDropComponente
            {...tarefasFiltroPageProps}
            list={dragDropComponente.listaKanbam}
            onDragEndOverride={dragDropComponente.onDragEndOverride}
          />
        </Row>
      </Container>
    </div>
  );
};

export default TarefasKanbanPage;



// WEBPACK FOOTER //
// ./src/pages/tarefas/tarefas.kanban.page.js